import { createSelector, createFeatureSelector } from '@ngrx/store';
import { GenesysCloudUsersState } from '../genesys-cloud-users.state';
import { featureKey } from '../reducers/user.reducers';
import { memoize } from 'lodash';

export const selectState = createFeatureSelector<GenesysCloudUsersState>(featureKey);
export const selectUser = createSelector(selectState, state => state.user);
export const selectUsersEntities = createSelector(selectState, state => state.users.entities);

export const selectUserById = memoize((userId: string) => createSelector(
  selectUsersEntities,
  entities => entities[userId]
));

export const selectUserNameById = memoize((userId: string) => createSelector(
  selectUserById(userId),
  user => user?.name
));
